import React, {useState} from 'react'
import useLearningCenterMutation from 'hec/hooks/learning-center/useLearningCenterMutation'
import {Button} from '@/components/ui/button'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import useLearningCenter from '~/app/hooks/use-learning-center'

const GoalBannerBtn = ({levelData, sfccLearningCenterData}) => {
    const [requestInProgress, setRequestInProgress] = useState(false)
    const {nextModuleID, nextModuleUrl, firstModuleUrl, complete, started, levelID, parentGoalID} =
        levelData
    const {getActiveGoal} = useLearningCenter()
    const {startLevel, startGoal, startModule, setActiveLesson} = useLearningCenterMutation()
    const history = useHistory()
    const activeGoal = getActiveGoal()

    const handleClick = async () => {
        if (!complete) {
            setRequestInProgress(true)
            let newData = structuredClone(sfccLearningCenterData)
            if (activeGoal?.id !== parentGoalID) {
                const {data} = await startGoal(parentGoalID)
                newData = typeof data === 'string' ? JSON.parse(data) : data
            }
            if (!started) {
                startLevel(levelID, parentGoalID, newData)
            }
            const response = await startModule(nextModuleID, levelID, newData)
            if (response.success) {
                setActiveLesson(firstModuleUrl)
                history.push(nextModuleUrl)
            } else {
                throw new Error(response.errorMsg)
            }
            setRequestInProgress(false)
        } else {
            history.push(firstModuleUrl)
        }
    }
    let ctaText = 'Get Started'
    if (started && !complete) {
        ctaText = 'Continue'
    } else if (complete) {
        ctaText = 'Review'
    }

    return (
        <Button
            ctaType="button"
            variant="primary"
            className="w-full lg:w-[12.25rem] mt-4 lg:mt-0 ml-0"
            onClick={handleClick}
            disabled={requestInProgress}
            data-testid="goalBannerBtn-Button"
        >
            {ctaText}
        </Button>
    )
}

GoalBannerBtn.propTypes = {
    levelData: PropTypes.object,
    sfccLearningCenterData: PropTypes.object
}

export default GoalBannerBtn
